export default __webpack_public_path__ + "static/media/rope.png";